import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SetTemplatePreview, getFormCreatorStore, getFormCreatorGalleryOpenStore, TemplateOpenFromGallery } from '@/store/formCreator/actions';
import { WebsiteModePreviewOverlay } from '@/components/TemplatePreviewComponent';
import { useHistoryBackActionContext } from '@/services/hooks/useHistoryBackAction';

export const PreviewOverlay = (): JSX.Element => {
    const dispatch = useDispatch();
    const historyBackAction = useHistoryBackActionContext();
    const { popBackCallback } = historyBackAction || {};
    const { templatePreview } = useSelector(getFormCreatorStore);
    const isGalleryOpen = useSelector(getFormCreatorGalleryOpenStore);

    const onTemplatePreviewClose = (isManualClose?: boolean): boolean => {
        dispatch(SetTemplatePreview());
        isManualClose && popBackCallback();
        return true;
    };

    const onEditClick = (): void => {
        dispatch(TemplateOpenFromGallery(templatePreview?.name, templatePreview?.isPublic));
        onTemplatePreviewClose(false);
    };

    if (!templatePreview?.content) return null;

    return (
        <WebsiteModePreviewOverlay
            name={templatePreview.name}
            previewContent={templatePreview.content}
            onClose={onTemplatePreviewClose}
            isPreviewEditable={isGalleryOpen}
            onEdit={onEditClick}
            fullWidthContent
        />
    );
};
